export var BucketSettingsNotificationSubject;
(function (BucketSettingsNotificationSubject) {
    BucketSettingsNotificationSubject["EditSuccess"] = "edit-aws-bucket-success";
    BucketSettingsNotificationSubject["EditFailure"] = "edit-aws-bucket-failure";
    BucketSettingsNotificationSubject["CreateSuccess"] = "create-aws-bucket-success";
    BucketSettingsNotificationSubject["CreateFailure"] = "create-aws-bucket-failure";
    BucketSettingsNotificationSubject["DeleteSuccess"] = "delete-aws-bucket-success";
    BucketSettingsNotificationSubject["DeleteFailure"] = "delete-aws-bucket-failure";
    BucketSettingsNotificationSubject["RegionGetFailure"] = "get-regions-failure";
    BucketSettingsNotificationSubject["LogTypesGetFailure"] = "get-logtypes-failure";
    BucketSettingsNotificationSubject["AccountIdGetFailure"] = "get-accountid-failure";
    BucketSettingsNotificationSubject["GetBuckets"] = "get-buckets";
})(BucketSettingsNotificationSubject || (BucketSettingsNotificationSubject = {}));
export var OperatingSystem;
(function (OperatingSystem) {
    OperatingSystem["Windows"] = "windows";
    OperatingSystem["Linux"] = "linux";
})(OperatingSystem || (OperatingSystem = {}));
export var Format;
(function (Format) {
    Format["Plain"] = "plain";
    Format["Json"] = "json";
})(Format || (Format = {}));
export var BucketEndpoints;
(function (BucketEndpoints) {
    BucketEndpoints["CloudTrail"] = "cloudtrails";
    BucketEndpoints["S3"] = "s3-buckets";
})(BucketEndpoints || (BucketEndpoints = {}));
export var LogzioSupportedBucketTypes;
(function (LogzioSupportedBucketTypes) {
    LogzioSupportedBucketTypes["CloudTrail"] = "cloudtrail";
    LogzioSupportedBucketTypes["Elb"] = "elb";
    LogzioSupportedBucketTypes["CloudFront"] = "cloudfront";
    LogzioSupportedBucketTypes["S3Access"] = "S3Access";
    LogzioSupportedBucketTypes["VPC"] = "vpcflow";
    LogzioSupportedBucketTypes["S3"] = "s3-buckets";
})(LogzioSupportedBucketTypes || (LogzioSupportedBucketTypes = {}));
export var AuthenticationTypes;
(function (AuthenticationTypes) {
    AuthenticationTypes["IAM"] = "iam";
    AuthenticationTypes["SecretAccess"] = "secret";
})(AuthenticationTypes || (AuthenticationTypes = {}));
export var ShipperTypes;
(function (ShipperTypes) {
    ShipperTypes["CUSTOM"] = "custom";
    ShipperTypes["RANDOM"] = "random";
    ShipperTypes["APPLICATION"] = "application";
    ShipperTypes["COGNITIVE"] = "cognitive";
})(ShipperTypes || (ShipperTypes = {}));
//# sourceMappingURL=log-shipping.enum.js.map